import {Model} from "ords/dist/model/model";

export class AssignmentPartText extends Model {
    getValueCompiledForShow() {
        // let text =
    }
}

export const AssignmentPartTextModelConfig = {
    name: 'assignmentPartText',
    model: AssignmentPartText
}
